module.exports = __webpack_public_path__ + "img/screen.ccd77fcc.png";